class CustomerMenu extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    this.details = this.querySelector("details");

    this.handleDocumentClick = (e) => {
      // Check that element has not been removed from DOM
      if (!document.body.contains(e.target)) return;

      if (this.details.open && !this.contains(e.target)) {
        this.close();
      }
    };

    this.handleKeyUp = (e) => {
      if (this.details.open && e.code.toUpperCase() === "ESCAPE") {
        this.close();
      }
    };

    document.addEventListener("keyup", this.handleKeyUp);
    document.addEventListener("click", this.handleDocumentClick);
  }

  disconnectedCallback() {
    document.removeEventListener("keyup", this.handleKeyUp);
    document.removeEventListener("click", this.handleDocumentClick);
  }

  close() {
    this.details.open = false;
  }
}

if (!customElements.get("customer-menu")) {
  customElements.define("customer-menu", CustomerMenu);
}
